import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Heading, Icon, Separator, Table, TableRow, TableCell, Tooltip } from 'telia-front-react';
import { FWA_TECHNOLOGIES } from '../util/InternetOfferUtil';
export const SecureNetPerks = (props) => {
    const { offer } = props;
    const { isMobile } = useIsMobileHook();
    const { translate } = React.useContext(TranslationsContext);
    const renderTableCell = (padding, content, className) => (React.createElement(TableCell, { padding: padding, valign: "middle", className: className },
        isMobile && React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
        content,
        isMobile && React.createElement(Separator, { color: "invisible", spacing: "xxsmall" })));
    const renderTableRow = (detailIcon, detailValue) => (React.createElement(TableRow, null,
        !isMobile && renderTableCell('none', React.createElement(Icon, { modifiers: `#${detailIcon}`, size: "sm" })),
        renderTableCell(isMobile ? 'none' : 'default', detailValue)));
    const securityFilterTooltip = () => {
        return `<>
      <TooltipToggle id={'security-filter-tooltip'}><strong>DDoS</strong></TooltipToggle>
    </>`;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: 1, className: "h4 text-bold" }, translate('secureNetCalculator.contents.description.title')),
        React.createElement(Table, null,
            React.createElement("tbody", null,
                !FWA_TECHNOLOGIES.includes(offer.technology) && (React.createElement(React.Fragment, null,
                    renderTableRow('security', translate('secureNetCalculator.contents.description.securityFilter', { tooltip: securityFilterTooltip() })),
                    React.createElement(Tooltip, { referenceElement: '#security-filter-tooltip' }, translate('secureNetCalculator.contents.securityFilter.tooltipContent')))),
                renderTableRow('time-round', translate('secureNetCalculator.contents.description.errorRestoration')),
                renderTableRow('ip', translate('secureNetCalculator.contents.description.ipAddress')))),
        React.createElement(Separator, { spacing: "xxsmall", weight: "thin" }),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
};
